
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import textFilter from "../../../../helper/textFilter"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { MdCheck } from "react-icons/md";
import { setSelectedLoadListCompany } from "../../../../features/loadList/loadListSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: 14px;
        font-weight: var(--font-weight-lg);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: 5px;
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }

        &::placeholder{
            color: ${({theme}) => theme.secondaryTextColor};
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .temizle-btn{
            font-size: 12px;
            font-weight: var(--font-size-lg);
            padding: 5px 20px;
            cursor: pointer;
        }

        .option{
            width: 100%;
            padding: 5px 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 20px;

            .checkbox{
                width: 22px;
                height: 22px;
                border: 1px solid ${({theme}) => theme.mainTextColor};
                border-radius: 3px;
                display: flex;
                justify-content: center;
                align-items: center;

                .check-icon{
                    font-size: 1.4rem;
                    fill: ${({theme}) => theme.mainTextColor};
                }
            }

            span{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const InputSelectLoadListFilter = ({data, setData, labelText, name, inputWidth, initialOptions, filterKey="companyName"}) => {

    const dispatch = useDispatch()


    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState([])

    useEffect(() => {
        setOptions(initialOptions)
    },[initialOptions])

    const [text, setText] = useState("")

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(initialOptions)
        }

        if(searchText){
            const result = textFilter(initialOptions, searchText, filterKey)
            setOptions(result)
        }

        setText(searchText)
    }


    const idList = data?.map(item => item.id)

    const handleOptionClick = (item) => {
        if(idList.includes(item.id)){
            dispatch(setSelectedLoadListCompany(data.filter(innerItem => {
                return innerItem.id !== item.id
            })))
            
        }
        else{
            dispatch(setSelectedLoadListCompany([...data, item]))
        }
    }

  return (
    <Container value={data?.length > 0} inputWidth={inputWidth} onClick={e => e.stopPropagation()}>
        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} placeholder={data?.map(item => item.companyName)} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        data?.length > 0 && <div className="temizle-btn" onClick={() => { dispatch(setSelectedLoadListCompany([])); dispatch(handleActiveSelect(null))}}>Listeyi Sıfırla</div>
                    }
                    {
                        options?.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                <div className="checkbox">
                                    {
                                        idList.includes(item.id) &&
                                        <MdCheck className="check-icon" />
                                    }
                                </div>
                                <span>{item.companyName}</span>
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputSelectLoadListFilter